var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "panel" }, [
    _c(
      "div",
      { staticClass: "panel-body" },
      [
        _c("q-list-header", [
          _vm._v("\n      Заявки (" + _vm._s(_vm.items.length) + ")\n    ")
        ]),
        _vm._v(" "),
        _vm._l(_vm.items, function(item, ind) {
          return _c("div", { key: item.id, staticClass: "panel panel-gray" }, [
            _c(
              "div",
              { staticClass: "panel-header" },
              [
                _c(
                  "div",
                  { staticClass: "panel-title" },
                  [
                    _c("q-icon", { attrs: { name: "fa-bell" } }),
                    _c("span", [_vm._v(" " + _vm._s(item.date))])
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.allowDelete &&
                (_vm.isAdmin || (_vm.isDispatcher && item.handled))
                  ? _c("q-btn", {
                      attrs: {
                        color: item.handled ? "positive" : "negative",
                        icon: "delete_forever",
                        round: "",
                        flat: "",
                        title: "Удалить"
                      },
                      on: {
                        click: function($event) {
                          _vm.doDelete(item)
                        }
                      }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.instrumentId && _vm.isDispatcher
                  ? _c("q-btn", {
                      attrs: {
                        icon: "fa-briefcase",
                        round: "",
                        flat: "",
                        title: "Создать кейс по заявке",
                        color: "positive"
                      },
                      on: {
                        click: function($event) {
                          _vm.$router.push(
                            "/icnew/" + _vm.instrumentId + "/" + item._id
                          )
                        }
                      }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.linkingEnabled
                  ? _c("q-btn", {
                      attrs: {
                        color: "primary",
                        icon: "fa-link",
                        round: "",
                        flat: "",
                        title: "Связать с кейсом"
                      },
                      on: {
                        click: function($event) {
                          _vm.linkToCase(item)
                        }
                      }
                    })
                  : _vm._e()
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "panel-body" }, [
              _c("p", [
                _c("small", { staticClass: "view-label" }, [_vm._v("Пин-код")]),
                _vm._v(" "),
                _c("span", { staticClass: "text-bolder" }, [
                  _vm._v(_vm._s(item.pin))
                ])
              ]),
              _vm._v(" "),
              _c(
                "p",
                [
                  _c("small", { staticClass: "view-label" }, [
                    _vm._v("Клиент")
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "text-bolder" }, [
                    _vm._v(_vm._s(item.hospital))
                  ]),
                  _vm._v(" "),
                  _c("q-btn", {
                    attrs: {
                      color: "primary",
                      icon: "search",
                      size: "sm",
                      dense: "",
                      round: "",
                      flat: "",
                      title: "Искать"
                    },
                    on: {
                      click: function($event) {
                        _vm.doSearch(ind, "hospital")
                      }
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "p",
                [
                  _c("small", { staticClass: "view-label" }, [_vm._v("Место")]),
                  _vm._v(" "),
                  _c("span", { staticClass: "text-bolder" }, [
                    _vm._v(_vm._s(item.place))
                  ]),
                  _vm._v(" "),
                  _c("q-btn", {
                    attrs: {
                      color: "primary",
                      icon: "search",
                      size: "sm",
                      dense: "",
                      round: "",
                      flat: "",
                      title: "Искать"
                    },
                    on: {
                      click: function($event) {
                        _vm.doSearch(ind, "place")
                      }
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "p",
                [
                  _c("small", { staticClass: "view-label" }, [
                    _vm._v("Прибор")
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "text-bolder" }, [
                    _vm._v(_vm._s(item.analyzer))
                  ]),
                  _vm._v(" "),
                  _c("q-btn", {
                    attrs: {
                      color: "primary",
                      icon: "search",
                      size: "sm",
                      dense: "",
                      round: "",
                      flat: "",
                      title: "Искать"
                    },
                    on: {
                      click: function($event) {
                        _vm.doSearch(ind, "analyzer")
                      }
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c("p", [
                _c("small", { staticClass: "view-label" }, [
                  _vm._v("Проблема")
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "text-bolder" }, [
                  _vm._v(_vm._s(item.defect))
                ])
              ]),
              _vm._v(" "),
              _c(
                "p",
                [
                  _c("small", { staticClass: "view-label" }, [
                    _vm._v("Контакт")
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "text-bolder" }, [
                    _vm._v(_vm._s(item.person))
                  ]),
                  _vm._v(" "),
                  _c("q-btn", {
                    attrs: {
                      color: "primary",
                      icon: "search",
                      size: "sm",
                      dense: "",
                      round: "",
                      flat: "",
                      title: "Искать"
                    },
                    on: {
                      click: function($event) {
                        _vm.doSearch(ind, "person")
                      }
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "p",
                [
                  _c("small", { staticClass: "view-label" }, [
                    _vm._v("Телефон")
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "text-bolder" }, [
                    _vm._v(_vm._s(item.telephone))
                  ]),
                  _vm._v(" "),
                  _c("q-btn", {
                    attrs: {
                      color: "primary",
                      icon: "search",
                      size: "sm",
                      dense: "",
                      round: "",
                      flat: "",
                      title: "Искать"
                    },
                    on: {
                      click: function($event) {
                        _vm.doSearch(ind, "telephone")
                      }
                    }
                  })
                ],
                1
              )
            ])
          ])
        })
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-77f87fc7", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-77f87fc7","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/requests-list.vue
// module id = null
// module chunks = 